// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","ScreenSMMin":"(min-width: 768px)","recipeTag":"G90be08"};